import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as firebase from 'firebase';
import './index.css';
import App from './components/app/app';
import registerServiceWorker from './registerServiceWorker';

var config = {
  apiKey: "AIzaSyCotSayJUGdCpOowOolKON64LxR7GhE8Iw",
  authDomain: "vexpo-7e57d.firebaseapp.com",
  databaseURL: "https://vexpo-7e57d.firebaseio.com",
  projectId: "vexpo-7e57d",
  storageBucket: "gs://vexpo-7e57d.appspot.com",
  messagingSenderId: "328696298790"
};

firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js